import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";
import './DownloadApplicationsModal.css';

const DownloadApplicationsModal = ({
    show,
    onClose,
    downloadScope,
    onScopeChange,
    filtersActive,
    onDownloadClick,
    isExporting, 
    progressPercent,
    exportError,
    title = "Download Applications",
}) => {
    return (
        <Modal 
            show={show} 
            onHide={onClose} 
            centered 
            backdrop="static"
            dialogClassName="delete-application-modal"
            keyboard={false}
        >
            <Modal.Body className="delete-modal-content">
                <div className="delete-modal-header">
                    {/* <h5 className="delete-modal-title">Download Applications</h5> */}
                    <h5 className="delete-modal-title">{title}</h5>

                    <button className="btn-close-custom" onClick={onClose}>
                        <IoMdClose size={24} />
                    </button>
                </div>

                <div className="delete-modal-body">
                    {
                        filtersActive 
                            ? <span>Active filters applied - export will include only filtered records</span> 
                            : null
                    }

                    <div className="mb-3">
                        <Form.Check
                            name="downloadScope"
                            id="download-scope-current"
                            label={
                                <div className="download-option-text">
                                    <span className="download-option-title">Current Page Only</span>
                                    <span className="download-option-sub">
                                        Download the records visible on this page
                                    </span>
                                </div>
                            }
                            type="radio"
                            value="current"
                            checked={downloadScope === "current"}
                            onChange={onScopeChange}
                            className={`download-option ${downloadScope === "current" ? "selected" : ""}`}
                        />
                    </div>

                    <div className="mb-3">
                        <Form.Check
                            name="downloadScope"
                            id="download-scope-all"
                            label={
                                <div className="download-option-text">
                                    <span className="download-option-title">All Pages</span>
                                    <span className="download-option-sub">
                                        All records visible matching current filters across all pages
                                    </span>
                                </div>
                            }
                            type="radio"
                            value="all"
                            checked={downloadScope === "all"}
                            onChange={onScopeChange}
                            className={`download-option ${downloadScope === "all" ? "selected" : ""}`}
                        />
                    </div>
                </div>
            

                <div className="delete-modal-footer">
                    <Button
                        variant="light"
                        className="delete-btn-outline"
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="download-btn-solid"
                        onClick={onDownloadClick}
                        disabled={isExporting}
                    >
                        {isExporting ? (
                            <>
                                <span className="buttonSpinner"></span>
                                Downloading...
                            </>
                        ) : (
                            <>
                                Download
                            </>
                        )}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DownloadApplicationsModal;